import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed, ref, onMounted, onUnmounted } from "../../../../../adapter-vue";
import TUIChatEngine, { TUIStore, StoreName, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
var ReadState;
(function (ReadState) {
  ReadState[ReadState["Read"] = 0] = "Read";
  ReadState[ReadState["Unread"] = 1] = "Unread";
  ReadState[ReadState["AllRead"] = 2] = "AllRead";
  ReadState[ReadState["NotShow"] = 3] = "NotShow";
  ReadState[ReadState["PartiallyRead"] = 4] = "PartiallyRead";
})(ReadState || (ReadState = {}));
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: {
      "default": function _default() {
        return {};
      }
    }
  },
  emits: ["openReadUserPanel"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    var TYPES = TUIChatEngine.TYPES;
    // 用户级别的已读回执开关 优先级最高
    var isDisplayMessageReadReceipt = ref(TUIStore.getData(StoreName.USER, "displayMessageReadReceipt"));
    onMounted(function () {
      TUIStore.watch(StoreName.USER, {
        displayMessageReadReceipt: onDisplayMessageReadReceiptUpdate
      });
    });
    onUnmounted(function () {
      TUIStore.unwatch(StoreName.USER, {
        displayMessageReadReceipt: onDisplayMessageReadReceiptUpdate
      });
    });
    var isShowReadStatus = computed(function () {
      if (!isDisplayMessageReadReceipt.value) {
        // 用户级已读回执开关关闭 不展示已读状态
        return false;
      }
      var _props$message = props.message,
        ID = _props$message.ID,
        type = _props$message.type,
        flow = _props$message.flow,
        status = _props$message.status,
        hasRiskContent = _props$message.hasRiskContent,
        conversationID = _props$message.conversationID,
        conversationType = _props$message.conversationType,
        _props$message$needRe = _props$message.needReadReceipt,
        needReadReceipt = _props$message$needRe === void 0 ? false : _props$message$needRe;
      // 异步消息打击 消息已发出判断是否存在风险内容
      if (hasRiskContent) {
        return false;
      }
      var _ref2 = TUIStore.getConversationModel(conversationID) || {},
        groupProfile = _ref2.groupProfile;
      // 直播群以及社群不展示已读状态
      if ((groupProfile === null || groupProfile === void 0 ? void 0 : groupProfile.type) === TYPES.GRP_AVCHATROOM || (groupProfile === null || groupProfile === void 0 ? void 0 : groupProfile.type) === TYPES.GRP_COMMUNITY) {
        return false;
      }
      if (type === TYPES.MSG_CUSTOM) {
        var message = TUIStore.getMessageModel(ID);
        // 如果是信令消息 不展示阅读状态
        if (message.getSignalingInfo() !== null) {
          return false;
        }
      }
      // 未成功消息 接收消息 不展示阅读状态
      if (flow !== "out" || status !== "success") {
        return false;
      }
      if (conversationType === "GROUP") {
        return needReadReceipt;
      } else if (conversationType === "C2C") {
        return true;
      }
      return false;
    });
    var readState = computed(function () {
      var _props$message2 = props.message,
        conversationType = _props$message2.conversationType,
        _props$message2$needR = _props$message2.needReadReceipt,
        needReadReceipt = _props$message2$needR === void 0 ? false : _props$message2$needR,
        _props$message2$isPee = _props$message2.isPeerRead,
        isPeerRead = _props$message2$isPee === void 0 ? false : _props$message2$isPee;
      var _props$message$readRe = props.message.readReceiptInfo,
        _props$message$readRe2 = _props$message$readRe.readCount,
        readCount = _props$message$readRe2 === void 0 ? 0 : _props$message$readRe2,
        _props$message$readRe3 = _props$message$readRe.unreadCount,
        unreadCount = _props$message$readRe3 === void 0 ? 0 : _props$message$readRe3,
        _props$message$readRe4 = _props$message$readRe.isPeerRead,
        isReceiptPeerRead = _props$message$readRe4 === void 0 ? false : _props$message$readRe4;
      if (conversationType === "C2C") {
        if (needReadReceipt) {
          return isReceiptPeerRead ? ReadState.Read : ReadState.Unread;
        } else {
          return isPeerRead ? ReadState.Read : ReadState.Unread;
        }
      } else if (conversationType === "GROUP") {
        if (needReadReceipt) {
          if (readCount === 0) {
            return ReadState.Unread;
          } else if (unreadCount === 0) {
            return ReadState.AllRead;
          } else {
            return ReadState.PartiallyRead;
          }
        } else {
          return ReadState.NotShow;
        }
      }
      return ReadState.Unread;
    });
    var readStatusText = computed(function () {
      var _props$message$readRe5 = props.message.readReceiptInfo.readCount,
        readCount = _props$message$readRe5 === void 0 ? 0 : _props$message$readRe5;
      switch (readState.value) {
        case ReadState.Read:
          return TUITranslateService.t("TUIChat.已读");
        case ReadState.Unread:
          return TUITranslateService.t("TUIChat.未读");
        case ReadState.AllRead:
          return TUITranslateService.t("TUIChat.全部已读");
        case ReadState.PartiallyRead:
          return "".concat(readCount).concat(TUITranslateService.t("TUIChat.人已读"));
        default:
          return "";
      }
    });
    var isUseUnreadStyle = computed(function () {
      var conversationType = props.message.conversationType;
      if (conversationType === 'C2C') {
        return readState.value !== ReadState.Read;
      } else if (conversationType === 'GROUP') {
        return readState.value !== ReadState.AllRead;
      }
      return false;
    });
    var isHoverFingerPointer = computed(function () {
      return props.message.needReadReceipt && props.message.conversationType === "GROUP" && (readState.value === ReadState.PartiallyRead || readState.value === ReadState.Unread);
    });
    function openReadUserPanel() {
      if (isHoverFingerPointer.value) {
        emits("openReadUserPanel");
      }
    }
    function onDisplayMessageReadReceiptUpdate(isDisplay) {
      isDisplayMessageReadReceipt.value = isDisplay;
    }
    return function (_ctx, _cache) {
      return _unref(isShowReadStatus) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass({
          'message-label': true,
          'unread': _unref(isUseUnreadStyle),
          'finger-point': _unref(isHoverFingerPointer)
        }),
        onClick: openReadUserPanel
      }, [_createElementVNode("span", null, _toDisplayString(_unref(readStatusText)), 1)], 2)) : _createCommentVNode("", true);
    };
  }
});